import React from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import { phoneNumberValidation} from '../../../Utils/CommonFunctions';

const phoneField = (props) => {
	//let fieldDetail = JSON.parse(props.fieldDetails);
	let value = props.value;
	let filterObject = props.filterObject;
	return (
		<Wrp>
		{
	        filterObject.input_value_type ?
	    		<input type="text" value={props.value} 
	    		className="form-control" 
	    		onChange={e=>props.filterOnChange(e, props.attr1, 'inputField', filterObject.has_multiple_input,props.attr5)} 
	    		onKeyPress={phoneNumberValidation}
	    		/>
	    	: null
		}
		</Wrp>
	);
}

export default phoneField;